import React, { useMemo } from "react";
import Form from "../../../components/form/form.component";
export default (children => {
  const isStickyFooterForm = useMemo(() => React.Children.toArray(children).some(child => /*#__PURE__*/React.isValidElement(child) && child.type?.displayName === Form.displayName && child.props.stickyFooter), [children]);
  return isStickyFooterForm;
});